import { IMedicalHistory } from '../interface/medical-history';
export class MedicalHistory implements IMedicalHistory {
    constructor(public MedHistoryId : number,public MedHistoryHeaderText : string,public MedHistoryDiscription : string){
        
    }
}



// WEBPACK FOOTER //
// ./src/app/section/master/model/medical-history.ts